var filter = document.querySelectorAll('.employee-filter');


for (let j = 0; j < filter.length; j++) {
    filter[j].addEventListener('click', function() {
        for (let k = 0; k < filter.length; k++) {
            filter[k].classList.remove('active');
        }

        filter[j].classList.add('active');
        
        const currentFilter = filter[j].dataset.category;
      
        const locations = document.querySelectorAll('.employees-location');

        locations.forEach(function(location) {
            if (location.id === currentFilter || currentFilter === '*') {
                location.classList.remove('filtered-out');
                location.classList.add('filtered-in');
                setTimeout(() => {
                    location.style.display = 'flex';
                }, 10); // Kurze Verzögerung, um die Animation zu ermöglichen
            } else {
                location.classList.remove('filtered-in');
                location.classList.add('filtered-out');
                setTimeout(() => {
                    location.style.display = 'none';
                }, 20); // Kurze Verzögerung, um die Animation zu ermöglichen
            }
        });
    });
}
